var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      color: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.794 13.705C15.7951 14.5296 15.6155 15.3444 15.268 16.0922C14.9205 16.84 14.4134 17.5026 13.7825 18.0334C13.1515 18.5643 12.4119 18.9505 11.6157 19.165C10.8195 19.3795 9.98598 19.417 9.17373 19.2748C8.36148 19.1327 7.5902 18.8144 6.91411 18.3424C6.23803 17.8703 5.67354 17.2559 5.2603 16.5423C4.84707 15.8287 4.5951 15.0333 4.52215 14.212C4.44919 13.3906 4.55701 12.5632 4.838 11.788C4.99591 11.3518 5.20755 10.9369 5.46801 10.553L10.334 1L14.995 10.805C15.5194 11.6814 15.7959 12.6837 15.795 13.705H15.794Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterManagement);
export default __webpack_public_path__ + "static/media/water-management.559182be49616126d6e8e0328c2c7f2f.svg";
export { ForwardRef as ReactComponent };